/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../../../../../$$_gendir/node_modules/@angular/material/typings/index.ngfactory';
import * as i2 from '@angular/material';
import * as i3 from '@angular/cdk/platform';
import * as i4 from '@angular/common';
import * as i5 from '../public-layout/public-layout.component.ngfactory';
import * as i6 from '../../../../../../app/modules/layout/components/public-layout/public-layout.component';
import * as i7 from '../../../../../../app/modules/layout/components/permission-error/permission-error.component';
import * as i8 from '../../../../../../app/modules/user/services/current-user/current-user.service';
import * as i9 from '../../../../../../app/modules/user/services/auth/auth.service';
const styles_PermissionErrorComponent:any[] = ['p[_ngcontent-%COMP%], .nav-bar[_ngcontent-%COMP%] {\n      text-align: center;\n    }\n    .nav-bar[_ngcontent-%COMP%] {\n      margin-top: 20px;\n    }'];
export const RenderType_PermissionErrorComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:0,
    styles:styles_PermissionErrorComponent,data:{}});
function View_PermissionErrorComponent_2(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),4,'button',[['class',
      'mat-button'],['md-button','']],[[8,'disabled',0]],[[(null as any),'click']],
      (_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>_co.location.back()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i1.View_MdButton_0,i1.RenderType_MdButton)),i0.ɵdid(1,16384,(null as any),
      0,i2.MdPrefixRejector,[[2,i2.MATERIAL_COMPATIBILITY_MODE],i0.ElementRef],(null as any),
      (null as any)),i0.ɵdid(2,180224,(null as any),0,i2.MdButton,[i0.Renderer2,i0.ElementRef,
      i3.Platform,i2.FocusOriginMonitor],(null as any),(null as any)),i0.ɵdid(3,16384,
      (null as any),0,i2.MdButtonCssMatStyler,([] as any[]),(null as any),(null as any)),
      (_l()(),i0.ɵted(-1,0,['Go back']))],(null as any),(_ck,_v) => {
    const currVal_0:any = (i0.ɵnov(_v,2).disabled || (null as any));
    _ck(_v,0,0,currVal_0);
  });
}
function View_PermissionErrorComponent_3(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),4,'button',[['class',
      'mat-button'],['md-button','']],[[8,'disabled',0]],[[(null as any),'click']],
      (_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>_co.auth.logout()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i1.View_MdButton_0,i1.RenderType_MdButton)),i0.ɵdid(1,16384,(null as any),
      0,i2.MdPrefixRejector,[[2,i2.MATERIAL_COMPATIBILITY_MODE],i0.ElementRef],(null as any),
      (null as any)),i0.ɵdid(2,180224,(null as any),0,i2.MdButton,[i0.Renderer2,i0.ElementRef,
      i3.Platform,i2.FocusOriginMonitor],(null as any),(null as any)),i0.ɵdid(3,16384,
      (null as any),0,i2.MdButtonCssMatStyler,([] as any[]),(null as any),(null as any)),
      (_l()(),i0.ɵted(-1,0,['Log Out']))],(null as any),(_ck,_v) => {
    const currVal_0:any = (i0.ɵnov(_v,2).disabled || (null as any));
    _ck(_v,0,0,currVal_0);
  });
}
function View_PermissionErrorComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),13,'div',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i0.ɵted(-1,(null as any),['\n        '])),(_l()(),i0.ɵeld(2,0,(null as any),
      (null as any),1,'p',([] as any[]),(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i0.ɵted(3,(null as any),['',''])),(_l()(),
      i0.ɵted(-1,(null as any),['\n        '])),(_l()(),i0.ɵeld(5,0,(null as any),
      (null as any),7,'div',[['class','nav-bar']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i0.ɵted(-1,(null as any),['\n          '])),
      (_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_PermissionErrorComponent_2)),
      i0.ɵdid(8,16384,(null as any),0,i4.NgIf,[i0.ViewContainerRef,i0.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i0.ɵted(-1,(null as any),['\n          '])),
      (_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_PermissionErrorComponent_3)),
      i0.ɵdid(11,16384,(null as any),0,i4.NgIf,[i0.ViewContainerRef,i0.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i0.ɵted(-1,(null as any),['\n        '])),
      (_l()(),i0.ɵted(-1,(null as any),['\n      ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_1:any = _co.hasRole;
    _ck(_v,8,0,currVal_1);
    const currVal_2:any = _co.auth.isAuthenticated();
    _ck(_v,11,0,currVal_2);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.message;
    _ck(_v,3,0,currVal_0);
  });
}
export function View_PermissionErrorComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵted(-1,(null as any),['\n    '])),(_l()(),i0.ɵeld(1,
      0,(null as any),(null as any),5,'app-public-layout',([] as any[]),(null as any),
      (null as any),(null as any),i5.View_PublicLayoutComponent_0,i5.RenderType_PublicLayoutComponent)),
      i0.ɵdid(2,114688,(null as any),0,i6.PublicLayoutComponent,([] as any[]),(null as any),
          (null as any)),(_l()(),i0.ɵted(-1,0,['\n      '])),(_l()(),i0.ɵand(16777216,
          (null as any),0,1,(null as any),View_PermissionErrorComponent_1)),i0.ɵdid(5,
          16384,(null as any),0,i4.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
              'ngIf']},(null as any)),(_l()(),i0.ɵted(-1,0,['\n    '])),(_l()(),i0.ɵted(-1,
          (null as any),['\n  ']))],(_ck,_v) => {
    var _co:i7.PermissionErrorComponent = _v.component;
    _ck(_v,2,0);
    const currVal_0:any = _co.loaded;
    _ck(_v,5,0,currVal_0);
  },(null as any));
}
export function View_PermissionErrorComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'app-permission-error',
      ([] as any[]),(null as any),(null as any),(null as any),View_PermissionErrorComponent_0,
      RenderType_PermissionErrorComponent)),i0.ɵdid(1,114688,(null as any),0,i7.PermissionErrorComponent,
      [i8.CurrentUserService,i9.AuthService,i4.Location],(null as any),(null as any))],
      (_ck,_v) => {
        _ck(_v,1,0);
      },(null as any));
}
export const PermissionErrorComponentNgFactory:i0.ComponentFactory<i7.PermissionErrorComponent> = i0.ɵccf('app-permission-error',
    i7.PermissionErrorComponent,View_PermissionErrorComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/$$_gendir/app/modules/layout/components/permission-error/permission-error.component.ngfactory.ts